import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import ContainedButtonGroup from "./BtnGroupsComponents/ContainedButtonGroup";
import OutlinedButtonGroup from "./BtnGroupsComponents/OutlinedButtonGroup";
import TextButtonGroup from "./BtnGroupsComponents/TextButtonGroup";
import WhiteContainedBtnGroup from "./BtnGroupsComponents/WhiteContainedBtnGroup";

const ButtonGroupPage = () => {
  return (
    <>
      <Paper elevation={0}>
        <PageTitleBox
          title={"Button Group"}
          description={
            "The ButtonGroup component can be used to group related buttons."
          }
        />
        <Divider light />
        <ContainedButtonGroup />
        <OutlinedButtonGroup />
        <TextButtonGroup />
        <WhiteContainedBtnGroup />
      </Paper>
    </>
  );
};

export default ButtonGroupPage;
